import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { setUser } from "@sentry/react";
import { useHelpScout } from "@/hooks/use-help-scout";
import { useProviderName } from "@/hooks/use-provider-name";

const IdentifyUser = () => {
  const { user, authStatus } = useAuthenticator();
  const posthog = usePostHog();
  const { identifyUser } = useHelpScout();
  const providerName = useProviderName();

  useEffect(() => {
    const asyncMethod = async () => {
      if (authStatus === "authenticated" && user) {
        setUser({
          id: user.userId,
          email: user.signInDetails?.loginId?.toLowerCase(),
          ip_address: "{{auto}}",
        });
      } else if (authStatus !== "authenticated") {
        setUser(null);
      }
    };

    asyncMethod();
  }, [authStatus, user]);

  useEffect(() => {
    if (posthog && user) {
      const userProperties = {
        user_type: "PROVIDER",
        email: user.signInDetails?.loginId,
      };
      posthog.identify(user.userId, userProperties);
    }
  }, [posthog, user]);

  useEffect(() => {
    if (authStatus === "authenticated" && user && providerName) {
      identifyUser({
        email: user.signInDetails?.loginId,
        company: providerName,
      });
    }
  }, [authStatus, user, providerName, identifyUser]);

  return null;
};

export default IdentifyUser;
